module.exports = {
      id: "play-solid-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "svg-sprite.svg#play-solid",
      toString: function () {
        return this.url;
      }
    }